/**
 * Copyright Mántum All Rights Reserved.
 */
import Internal from '../internal/select';
import ReactSelect from 'react-select';
import { forwardRef, useMemo } from 'react';

import type { Detail, Option, Validation } from '@mantum/kanela';

type PropTypes = {
    advanced?: {
        menuShouldScrollIntoView?: boolean;
        no?: string;
        placement?: 'auto' | 'top' | 'bottom';
        position?: 'fixed' | 'absolute';
        yes?: string;
    };
    disabled?: boolean;
    error?: boolean;
    name?: string;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onChange?: (name?: string, value?: Option<unknown> | unknown) => void;
    optional?: boolean;
    placeholder?: string;
    testid?: string;
    validation?: Validation;
    value?: boolean;
};

export default forwardRef<Detail<unknown>, PropTypes>(
    function Activate(props, ref) {
        // prettier-ignore
        const {
            advanced = {}
        } = props;

        // prettier-ignore
        const {
            yes = 'Si',
            no = 'No'
        } = advanced;

        const dataSource = [
            {
                label: yes,
                value: true
            },
            {
                label: no,
                value: false
            }
        ];

        const value = useMemo(() => {
            return props.value !== undefined
                ? {
                      label: props.value ? yes : no,
                      value: props.value
                  }
                : undefined;
        }, [props.value, yes, no]);

        return (
            <Internal
                {...props}
                advanced={{
                    ...advanced,
                    result: 'simple'
                }}
                dataSource={dataSource}
                ref={ref}
                render={ReactSelect}
                searchable={true}
                value={value}
            />
        );
    }
);
